import { useState } from "react";
import { FaCheck, FaRegCopy } from "react-icons/fa6";

interface Props {
  toCopy: string;
}

export const ClickToCopyButton = ({ toCopy }: Props) => {
  const [copied, setCopied] = useState(false);

  function handleCopy() {
    navigator.clipboard.writeText(toCopy).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }

  return (
    <button
      type="button"
      onClick={handleCopy}
      className="flex items-center justify-between gap-2 w-full text-sm bg-gray-300 hover:bg-gray-400 transition-colors px-3 py-2 rounded cursor-pointer"
    >
      {toCopy}
      <span className="shrink-0 text-gray-500">
        {copied ? <FaCheck className="text-green-500" /> : <FaRegCopy />}
      </span>
    </button>
  );
};
